import { Badge } from "@/components/ui/badge";

const MAP = {
  paid: "border-[#008A52]/30 bg-[#008A52]/10 text-[#008A52]",
  partial: "border-[#B7791F]/30 bg-[#B7791F]/10 text-[#B7791F]",
  unpaid: "border-[#E02424]/30 bg-[#E02424]/10 text-[#E02424]",
};

export default function StatusBadge({ status }) {
  return (
    <Badge variant="outline" className={`capitalize ${MAP[status] || ""}`} data-testid={`status-badge-${status}`}>
      {status}
    </Badge>
  );
}
